import { render, staticRenderFns } from "./BulkIssueOverview.vue?vue&type=template&id=54698ab0&scoped=true"
import script from "./BulkIssueOverview.vue?vue&type=script&lang=js"
export * from "./BulkIssueOverview.vue?vue&type=script&lang=js"
import style0 from "./BulkIssueOverview.vue?vue&type=style&index=0&id=54698ab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54698ab0",
  null
  
)

export default component.exports